
import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button, Row, Col, Container, Form, Card, InputGroup} from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';

function Sub_Group_Master() {

  const [hdnirn, setHdnIRN] = useState('');
  const [hdnMainGrpCd, setHdnMainGrpCd] = useState('');
  const [txtSubGroupDesc, setTxtSubGroupDesc] = useState('');
  const [ddlGroup, setDDLGroup] = useState('');
  const [orderPL, setOrderPL] = useState('');
  const [orderBL, setOrderBL] = useState('');
  const [ddlGrpCdView, setDDLGrpCdView] = useState('');
  const [subgroupData, setSubGroupData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);

  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_fin_group`);
        setGroupList(res.data || []);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroups();
  }, []);

  const handleRowClick = async (sub_grp_cd, grp_cd, sub_grp_desc, main_grp_cd, order_pl, order_bl) => {

    try {

      setHdnIRN(sub_grp_cd);
      setHdnMainGrpCd(main_grp_cd);
      setTxtSubGroupDesc(sub_grp_desc);
      setDDLGroup(grp_cd);
      setOrderBL(order_bl);
      setOrderPL(order_pl);
      setIsEditable(true);

    } catch (error) {
      console.error('Error fetching Level 3 group data:', error);
    }
  };

  const handleOrderPL = (e) => {

    let value = e.target.value;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    setOrderPL(value);

  };

  const handleOrderBL = (e) => {

    let value = e.target.value;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    setOrderBL(value);

  };

  const handleClear = () => {

    const isConfirmed = window.confirm("Sure you want to clear the record?");
    if (!isConfirmed) return;


    setHdnIRN('');
    setHdnMainGrpCd('');
    setDDLGroup('');
    setTxtSubGroupDesc('');
    setOrderBL('');
    setOrderPL('');
    setIsEditable(false);

  };

  const handleNewRow = () => {

    setHdnIRN('');
    setHdnMainGrpCd('');
    setDDLGroup('');
    setTxtSubGroupDesc('');
    setOrderBL('');
    setOrderPL('');
    setIsEditable(true);

  };

  const handleSubGroupView = async (e) => {

    setDDLGrpCdView(e.target.value)

    setSubGroupData([]);

    const response = await axios.get(`${BASE_URL}/api/get_subgroup_view`, {params : {p_GrpCd: e.target.value }});

    if (response.data.length > 0) {  
      setSubGroupData(response.data);
    }

  };

  const handleSave = async () => {

    if (!txtSubGroupDesc) {
      alert("Please enter Sub Group Desc !");
      return;
    }
    else if (!ddlGroup || ddlGroup === '') {
      alert("Please select Group !");
      return;
    }

    try {
      // Adjust the API endpoint and method based on your backend
      const payload = {
        sub_grp_cd: hdnirn,
        grp_cd: ddlGroup,
        mainGrpCd: hdnMainGrpCd,
        subgroupDesc: txtSubGroupDesc,
        orderPL: orderPL,
        orderBL: orderBL,
      };

      const isConfirmed = window.confirm("Sure you want to save the record?");
      if (!isConfirmed) return;

      const response = await axios.post(`${BASE_URL}/api/save_SubGroups`, payload);

      if (response.data.message === '1') {
        alert("Sub-Group saved successfully!");
        setIsEditable(false);
        setHdnIRN('');
        setHdnMainGrpCd('');
        setDDLGroup('');
        setTxtSubGroupDesc('');
        setOrderBL('');
        setOrderPL('');
        setSubGroupData([]);
        setDDLGrpCdView('');
      }


    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save Sub-Group Master.", error);
    }

  };

  return (

    <Container fluid className="p-3">

      {/* <Card className="p-3 shadow-sm" > */}
      <Card className="p-3" >

        <Row className="mb-2 ">
          <Col md={6} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Sub-Group Desc</InputGroup.Text>
              <input className="form-control" type="text"
                //style={{ marginTop: '10px' }} 
                value={txtSubGroupDesc}
                onChange={(e) => setTxtSubGroupDesc(e.target.value.toUpperCase())}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
          <Col md={6} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Group</InputGroup.Text>
              <Form.Select name="ddlGroup" value={ddlGroup} onChange={(e) => setDDLGroup(e.target.value)} >
                <option value="">-- Select Group --</option>
                {groupList.map((grp) => (
                  <option key={grp.grp_cd} value={grp.grp_cd}>
                    {grp.grp_desc}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-2 ">
          <Col md={3} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Order P/L</InputGroup.Text>
              <input className="form-control text-end" type="text"
                value={orderPL} 
                onChange={handleOrderPL}
                disabled={!isEditable} />
            </InputGroup>
          </Col>
          <Col md={3} className="d-flex align-items-start">
            <InputGroup>
              <InputGroup.Text>Order B/L</InputGroup.Text>
              <input className="form-control text-end" type="text"
                value={orderBL}
                onChange={handleOrderBL}
                disabled={!isEditable} />
            </InputGroup>
          </Col>


          <Col md={6} className="d-flex justify-content-end">
            <Button variant="primary" className="me-2" style={{width: "100px"}} disabled={isEditable} onClick={handleNewRow}>New</Button>
            <Button variant="secondary" className="me-2" style={{width: "100px"}} onClick={handleClear}>Clear </Button>
            <Button variant="success" className="me-2" style={{width: "100px"}} onClick={handleSave} disabled={!isEditable}>Save</Button>
          </Col>
        </Row>

      </Card>

      <Card className="p-3 shadow-sm" style={{ marginTop: '10px' }}>

        <Row className="mb-3">

          <Col md={6} className="d-flex align-items-center">
            <InputGroup>
              <InputGroup.Text>Group</InputGroup.Text>
              <Form.Select name="ddlGrpCdView" value={ddlGrpCdView} onChange={handleSubGroupView} >
                <option value="">-- Select Group --</option>
                {groupList.map((grp) => (
                  <option key={grp.grp_cd} value={grp.grp_cd}>
                    {grp.grp_desc}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

        </Row>

        <div className="table-wrapper">
          <table className="responsive-table">
            <thead>
              <tr>
                <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '30%' }}>Sub-Group Desc</th>
                <th style={{ textAlign: 'center', background: 'lightblue', color: 'black', width: '20%' }}>Group</th>
                <th style={{ textAlign: 'center', background: 'lightblue', color: 'black', width: '10%' }}>Main Group</th>
                <th style={{ textAlign: 'right', background: 'lightblue', color: 'black', width: '5%' }}>Order PL</th>
                <th style={{ textAlign: 'right', background: 'lightblue', color: 'black', width: '5%' }}>Order BL</th>
              </tr>
            </thead>
            <tbody>
              {subgroupData.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>No Group Found</td>
                </tr>
              ) : (
                subgroupData.map((item, index) => (
                  <tr key={index} onClick={() => handleRowClick(item.sub_grp_cd, item.grp_cd, item.sub_grp_desc, item.main_grp_cd, item.order_pl, item.order_bl)}
                   style={{ cursor: 'pointer', height: '40px' }}>
                    <td style={{ display: 'none' }}>{item.sub_grp_cd}</td>
                    <td style={{ textAlign: 'left'}}>{item.sub_grp_desc}</td>
                    <td style={{ textAlign: 'left'}}>{item.grp_desc}</td>
                    <td style={{ textAlign: 'center'}}>{item.main_grp_desc}</td>
                    <td style={{ textAlign: 'right'}}>{item.order_pl}</td>
                    <td style={{ textAlign: 'right'}}>{item.order_bl}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </Card>

    </Container>
  )
}

export default Sub_Group_Master;
